import { useContext, useEffect, useRef, useState } from 'react';
import { FormUtility } from '../../../Utility/FormUtility';
import Input from '../../../Form/Input';
import Select from '../../../Form/Select';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Utente } from '../../../../models/Utente';
import { Comune } from '../../../../models/Comune';
import { UtenteComune } from '../../../../models/UtenteComune';
import { UserService } from '../../../../services/UserService';
import { ComuneService } from '../../../../services/ComuneService';
import ToastContext from '../../../../contexts/toast';
import StatusContext from '../../../../contexts/status';
import { rolesCodes } from '../../../../constants/Roles';
import { useSelector } from 'react-redux';
import { tipologiaUtente } from '../../../../constants/TipologiaUtente';

export default function GestioneAnagraficaOperatore() {
  const location = useLocation();
  const params = useParams();
  const navigation = useNavigate();

  const [validate, setValidate] = useState(false);
  const [inputErrors, setInputErrors] = useState([]);
  const [inSave, setInSave] = useState(false);
  const [enteId,setEnteId] = useState(null);

  const utenteId = params.userId;
  const enteParamId = params.enteId ? parseInt(params.enteId) : null;

  const regExprFiscalCode =
    '^([A-Za-z]{6}[0-9LMNPQRSTUVlmnpqrstuv]{2}[ABCDEHLMPRSTabcdehlmprst][0-9LMNPQRSTUVlmnpqrstuv]{2}[A-Za-z][0-9LMNPQRSTUVlmnpqrstuv]{3}[A-Za-z])$';
  const regExprEmail ='^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$';
  const [utente, setUtente] = useState(new Utente());
  const [comune, setComune] = useState(new Comune());
  const [utenteComune, setUtenteComune] = useState(new UtenteComune());
  const [comuni, setComuni] = useState(null);

  const [disabledForm, setDisabledForm] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const roles = useSelector((state) => state.role);

  const userService = new UserService();
  const comuneService = new ComuneService();
  const utility = new FormUtility({ data: roles });

  const toastContext = useContext(ToastContext);
  const statusContext = useContext(StatusContext);

  const formRef = useRef(null);

  const isReferente = location.pathname.startsWith('/anagrafica-referente');

  useEffect(() => {
    console.log( 'params.enteId', params.enteId);
    setEnteId( params.enteId);
    if (params.enteId) {
      comuneService.getById(params.enteId).then(resp => {
        setComune(resp);
        setComuni([ resp ]);
      });
    }

    if (utenteId) {
      const service = isNaN(parseInt(utenteId)) ? userService.getByFiscalCode : userService.getById;
      service(utenteId)
        .then((resp) => {
          setUtente({ ...resp });
          setUtenteComune({ ...resp.comuniOpRef?.find(cor => cor.comuneId.toString() === params.enteId) });
          setLoadingData(false);
          setDisabledForm(false);
        })
        .catch((error) => {
          toastContext.error(utility.getErrorMsg(error), 12000);
          setLoadingData(false);
        });
    } else if (!utenteId) {
      const fetchComuni = async () => {
        const comuniSemplici = await comuneService.getAllByTipologiaAndDenominazioneRegione('Comune', 'Toscana', 'noDismessi');
        const unioni = await comuneService.getAllByTipologiaAndDenominazioneRegione('Unione di Comuni', 'Toscana');
        const gestioniAssociate = await comuneService.getAllByTipologiaAndDenominazioneRegione('Gestione Associata', 'Toscana');
        const arrayEnti = [ ...comuniSemplici, ...unioni, ...gestioniAssociate ].sort((a,b) => a.denominazione.localeCompare(b.denominazione));
        setComuni(arrayEnti);
      }

      if (utility.checkRoles([rolesCodes.regione])) {
        fetchComuni();
      } else {
        const ente = roles?.referenze?.find(c => c.id == roles.enteSelected);
        if (ente){
            setComuni([ ente ]);
            setEnteId( ente.id);
        }
        else{
            setComuni([ ...roles.referenze ]);
        }
        setComune(roles.referenze.find(c => c.id == roles.enteSelected) ?? roles.operatori.find(c => c.id == roles.enteSelected));
      }
    }

    return () => {
      statusContext.removeEvent('onbeforeunload');
    };
  }, []);

  const onChangeFiscalCode = (event) => {
    onChangeUtenteValue(event);

    const value = event.target.value;
    if (value.length === 16) {
      setLoadingData(true);
      setDisabledForm(true);
      userService
        .getByFiscalCodePerAssociazione(value)
        .then((resp) => {
          setLoadingData(false);
          setDisabledForm(false);
          const oldEmail = utenteComune.emailIstituzionale;
          const oldTelefono = utenteComune.telefonoIstituzionale;
          setUtente({ ...resp, codiceFiscale: value });
          setUtenteComune(comune?.id ? { ...resp.comuniOpRef?.find(cor => cor.id.comuneId.toString() === (enteId || comune.id.toString())) } : {});
          if (isReferente){
            setUtenteComune({utenteComune,emailIstituzionale:oldEmail,telefonoIstituzionale:oldTelefono});
          }
        })
        .catch(error => {
          setLoadingData(false);
          setDisabledForm(false);
          setUtente({ codiceFiscale: value });
          toastContext.error(utility.getErrorMsg(error), 12000);
        });
    }
  };

  const onChangeEnte = (event) => {
    const value = event.target.value;
    setComune(value ? comuni.find(c => c.id === parseInt(value)) : null);
    if (utente.id) {
      setUtenteComune({ ...utente.comuniOpRef?.find(cor => cor.id.comuneId.toString() === value) });
    }
    onChangeUtenteValue(event);
  }

  const onChangeTelephone = async (event) => {
    onChangeUtenteComuneValue({ target: { name: event.target.name, value: event.target.value.replace(/[^0-9]/g, '') } });
  }

  const onChangeUtenteComuneValue = async (event) => {
    const target = event.target;
    utenteComune[target.name] = target.value;
    setUtenteComune({ ...utenteComune });

    statusContext.addEvent('onbeforeunload');

    if (validate) {
      setFormErrors(false);
    }
  };

  const onChangeUtenteValue = async (event) => {
    const target = event.target;
    utente[target.name] = target.value;
    setUtente({ ...utente });

    statusContext.addEvent('onbeforeunload');

    if (validate) {
      setFormErrors(false);
    }
  };

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    setInputErrors(errors.map((el) => el.id));
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  };

  const denyOperation = () => {
    const route = isReferente
            ? '/gestione-adesione-enti'
            : `/gestione-operatori`;
    navigation(route);
  };

  const sendData = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setValidate(true);

    const validity = formRef.current.checkValidity();
    if (!validity) {
      setFormErrors();
      return;
    }

    setInSave(true);

    setInputErrors([]);

    utente.nuovoEnte = {
      ...utenteComune,
      utenteId: utente.id,
      comuneId: comune.id,
      tipologia: isReferente ? tipologiaUtente.referenteComunale : tipologiaUtente.operatoreComunale
    };

    const comuniReferente = utente.comuniOpRef?.filter(el => el.tipologia === tipologiaUtente.referenteComunale);
    const comuniOperatore = utente.comuniOpRef?.filter(el => el.tipologia === tipologiaUtente.operatoreComunale);

    const isPresentRef = comuniReferente?.find(el => el.id.comuneId === comune.id && el.id.comuneId !== enteParamId);
    const isPresentOpe = comuniOperatore?.find(el => el.id.comuneId === comune.id && el.id.comuneId !== enteParamId);
    if (isPresentRef || isPresentOpe) {
      toastContext.error(`L’operatore è già abilitato ${isPresentRef ? 'come referente' : ''} per questo ente`, 12000);
      setInSave(false);
      return;
    }

    utente.codiceFiscale = utente.codiceFiscale.toUpperCase();

    const service = utente.id ? userService.update : userService.create;
    service(utente)
      .then(() => {
        toastContext.success(
          'Operatore ' +
            (utenteId ? 'aggiornato' : 'aggiunto') +
            ' con successo!',
          4000
        );
        statusContext.removeEvent('onbeforeunload');

        setTimeout(() => {
          const route = isReferente
              ? '/gestione-adesione-enti'
              : `/gestione-operatori${enteParamId ? '/' + enteParamId : ''}`;
          navigation(route);
        }, 100);

        setInSave(false);
      })
      .catch((error) => {
        toastContext.error(utility.getErrorMsg(error), 12000);
        setInSave(false);
      });
  };

  return (
    <div className='rtds-container rtds-my-12 '>
      <div className='rtds-mb-6'>
        <h1 className='rtds-text-2xl rtds-font-bold'> {`${utenteId ? 'Modifica':'Inserisci'} ${!isReferente?'Operatore':'Referente'}`}</h1>
        
      </div>
      <div className='rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02'>
        <div className='rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02'>
          <p>
            I campi obbligatori sono contrassegnati da un asterisco&nbsp;
            <abbr
              className='rtds-font-bold rtds-no-underline'
              title='obbligatorio'
            >
              *
            </abbr>
          </p>
        </div>

        <form
          noValidate
          ref={formRef}
          id='hasValidationForm'
          className='has-js-validation-form rtds-py-6 rtds-space-y-4'
          onSubmit={sendData}
        >
          <div className='rtds-field-row'>
            <Select
              classDiv={'rtds-mt-3 lg:rtds-mt-0'}
              label={'Ente'}
              required={!utenteId}
              id={'comune'}
              inputErrors={inputErrors}
              classSelect={''}
              onChange={(event) => onChangeEnte(event)}
              baseOption={'Seleziona Ente'}
              options={comuni}
              bindKey={'id'}
              bindValue={'denominazione'}
              value={comune?.id || ''}
              disabled={loadingData || enteId}
            />
          </div>
          <div className='rtds-field-row'>
            <Input
              classDiv={'rtds-mt-3 lg:rtds-mt-0'}
              label={'Codice Fiscale'}
              required
              pattern={regExprFiscalCode}
              id={'codiceFiscale'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-uppercase'}
              type={'text'}
              onChange={(event) => onChangeFiscalCode(event)}
              value={utente.codiceFiscale || ''}
              errorMessage={utility.checkFiscalCodeValidity(validate, utente.codiceFiscale, regExprFiscalCode)}
              minLength={16}
              maxLength={16}
              disabled={utenteId || loadingData}
              loading={loadingData}
              hideMaxLength
            />

            <Input
              label={'Nome'}
              id={'nome'}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'text'}
              onChange={(event) => onChangeUtenteValue(event)}
              value={utente.nome || ''}
              readOnly
            />

            <Input
              classDiv={'rtds-mt-3 lg:rtds-mt-0'}
              label={'Cognome'}
              id={'cognome'}
              classInput={'rtds-text-sm rtds-input-placeholder'}
              type={'text'}
              onChange={(event) => onChangeUtenteValue(event)}
              value={utente.cognome || ''}
              readOnly
            />
          </div>
          <div className='rtds-field-row'>
            <Input
              label={'Telefono Istituzionale'}
              id={'telefonoIstituzionale'}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              classDivInput={'rtds-input rtds-background-04 rtds-rounded-lg'}
              type={'tel'}
              onChange={(event) => onChangeTelephone(event)}
              value={utenteComune.telefonoIstituzionale || ''}
              disabled={loadingData}
              maxLength={10}
              hideMaxLength
              addon
            />

            <Input
              classDiv={'rtds-mt-3 lg:rtds-mt-0 '}
              label={'Email Istituzionale'}
              required
              id={'emailIstituzionale'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder'}
              type={'email'}
              onChange={(event) => onChangeUtenteComuneValue(event)}
              value={utenteComune.emailIstituzionale || ''}
              disabled={disabledForm || loadingData}
              maxLength={254}
              errorPattern={'Formato non valido'}
              hideMaxLength
              pattern={regExprEmail}
            />
          </div>

          <div className='rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center'>
            <div className='rtds-form-actions'>
              <div
                className='rtds-inline-flex rtds-gap-1'
                role='group'
                aria-label='Azioni'
              >
                <button
                  type='button'
                  className='rtds-btn rtds-btn--secondary rtds-form-submit rtds-btn--icon-left rtds-group/button'
                  onClick={() => denyOperation()}
                  disabled={inSave}
                >
                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                    />
                  </svg>{' '}
                  Annulla
                </button>
                <button
                  type='submit'
                  className='rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button'
                  disabled={disabledForm || loadingData || inSave}
                >
                  
                  {utenteId ? 'Salva' : 'Salva'}

                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${utenteId ? 'solid--chevron-right' : 'solid--chevron-right'}`}
                    />
                  </svg>
                  {/* <svg
                    className='rtds-icon rtds-fill-current rtds-w-12 rtds-h-12 rtds-animate-spin'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                    hidden={inSave}
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                    />
                  </svg> */}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
